module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1521-17ee07cae2c855152fa67959e3e0c725.png";